const compareLabel = (a, b) => a.label.localeCompare(b.label);

const getPlacementOptions = ({ list }) => {
    const activePlacements2 = Object.entries(list)
        .filter(e => e[1].active)
        .map(([id, el]) => ({ value: id, label: el.name }))
        .sort(compareLabel);

    const idsByPlacementLabels = activePlacements2.reduce((acc, p) => {
        acc[p.label] = acc[p.label] || [];
        acc[p.label].push(p.value);
        return acc;
    }, {});

    const groupedPlacements = Object.keys(idsByPlacementLabels).map(key => {
        return { label: key, value: idsByPlacementLabels[key] };
    });

    return groupedPlacements;
};

export default getPlacementOptions;
